import React, { useEffect, useState } from 'react';
import { Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { useSelector } from 'react-redux';
import Selector from '../Selector';
import List from '../List';
import Recipe from '../Recipe';
import vector from '../../assets/favorite.png';
import './styles.sass';

const useStyles = makeStyles({
    text: {
        '&&': {
            fontFamily: `'Rubik', sasn-serif`,
            wordWrap: "break-word",
            textAlign: 'center'
        }
    }
});

const Favorites = ({ showRecipe, setShowRecipe }) => {
    const [selectedCategory, setSelectedCategory] = useState('');
    const [categories, setCategories] = useState([]);
    const recipes = useSelector(state => state.recipes);
    const favorites = recipes.filter((recipe) => recipe.favorite && recipe.category.includes(selectedCategory));
    const classes = useStyles();

    useEffect(() => {
        setCategories([...new Set(favorites.map(recipe => recipe.category))]);
    }, []);

    return !showRecipe ? (
        <div className="favorites-container">
            {favorites.length > 0 ?
                <>
                    <Selector
                        categories={categories}
                        selectedCategory={selectedCategory}
                        setSelectedCategory={setSelectedCategory}
                        origin='כל המועדפים'
                    />
                    <List
                        recipes={favorites}
                        setShowRecipe={setShowRecipe}
                    />
                </>
                :
                <div className="no-favorites-container">
                    <img src={vector} alt="Vector" className="image" />
                    <Typography display="inline" variant='h5' className={classes.text}>עוד לא הוספת מתכונים מועדפים</Typography>
                </div>
            }
        </div>
    ) : (
        <Recipe setShowRecipe={setShowRecipe} />
    )
}

export default Favorites;